import React from 'react';

const Footer = () => {
    return (
        <footer className='lm-footer'>
            2026© Leadmerge.
        </footer>
    );
};

export default Footer;
